// extracted by mini-css-extract-plugin
module.exports = {"CatalogButton":"catalog_CatalogButton__m9aOQ","CatalogButtonScrolled":"catalog_CatalogButtonScrolled__DrVv3"};